// extracted by mini-css-extract-plugin
module.exports = {"container":"DropDownListItemDivider_container__3xYrQ","sending":"DropDownListItemDivider_sending__vl7Vj"};